import IOneTimePasswordDto from "@application/models/IOneTimePasswordDto";
import IUserGenerateOneTimePasswordDto from "@application/requestsModels/IUserGenerateOneTimePasswordDto";
import IUserLoginWithEmailAndPasswordDto from "@application/requestsModels/IUserLoginWithEmailAndPasswordDto";
import IUserLoginWithOneTimePasswordDto from "@application/requestsModels/IUserLoginWithOneTimePasswordDto";
import IGenericApiResponse from "@view/common/ApiClient/IGenericApiResponse"
import { api } from "./config";
import { ISignInProcessInitWithUrlDto } from "@presentation/controllersModels/ISignInProcessInitWithUrlDto";
import IUserSendVerificationCodeDto from "@application/requestsModels/IUserSendVerificationCodeDto";
import { IUserConfirmEmailForIngressToFundingOpportunityApplicationDto } from "@application/requestsModels/IUserConfirmEmailForIngressToFundingOpportunityApplicationDto";

export function loginWithEmailAndPassword(dto: IUserLoginWithEmailAndPasswordDto): Promise<IGenericApiResponse<ISignInProcessInitWithUrlDto>> {
  return api.post("user/login", dto);
}

export function generateOtp(dto: IUserGenerateOneTimePasswordDto): Promise<IGenericApiResponse<IOneTimePasswordDto>> {
  return api.post("user/generateOtp", dto);
}

export function loginWithOtp(dto: IUserLoginWithOneTimePasswordDto): Promise<IGenericApiResponse<ISignInProcessInitWithUrlDto>> {
  return api.post("user/loginWithOtp", dto);
}

export function sendVerificationCode(dto: IUserSendVerificationCodeDto): Promise<IGenericApiResponse<IOneTimePasswordDto>> {
  return api.post("user/sendVerificationCode", dto);
}

export function confirmEmailForIngress(
  dto: IUserConfirmEmailForIngressToFundingOpportunityApplicationDto,
): Promise<IGenericApiResponse<boolean>> {
  return api.post("user/confirm-email", dto);
}